import React from "react";
import ReactDOM from "react-dom/client";

// #TODO remove this for tree shaking
import "@/lib/echo";
import "@/lib/i18n";

import "./index.css";

import App from "./App";

const rootEl = document.getElementById("root")!;

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

function removeSplash() {
  document.body.style.overflow = "initial";
  document.getElementById("splash")?.remove();
}

if (rootEl.childElementCount > 0) {
  removeSplash();
} else {
  const observer = new MutationObserver(() => {
    if (rootEl.childElementCount > 0) {
      observer.disconnect();
      removeSplash();
    }
  });
  observer.observe(rootEl, { childList: true });
}

if (import.meta.env.PROD && import.meta.env.VITE_CLARITY_ID) {
  import("@microsoft/clarity").then(({ default: Clarity }) => {
    Clarity.init(import.meta.env.VITE_CLARITY_ID!);
  });
}
